import React from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import Step from '@components/PageStep';
import Link from 'next/link';
import {useTranslation} from '@common/hooks/useTranslation';
import {ITranslation} from '@common/types';
import DetailPageHeader from '@components/DetailPageHeader';


export const Vacancy = () => {
  const {vacancy} = useTypedSelector(state => state.vacancies);
  const t = useTranslation('vacancy') as ITranslation['vacancy'];

  return (
    <div>
      <DetailPageHeader {...vacancy?.detail}/>

      {vacancy?.steps?.map((item, index) => (
        <Step
          key={`step_${index}`}
          count={item.count}
          classNames={[]}
          step={item.step}
          stepChildren={item.children}
        />
      ))}

      <section className="inner-grid inner-grid--margin-bottom">
        <div className="container">
          <h2 className="visually-hidden">{t.contact?.title}</h2>
          <div className="inner-grid__content">
            <div className="inner-simple-text inner-simple-text--mobile-margin-big inner-simple-text--big">
              <p>{t.contact?.firstText}</p>
            </div>
            <div
              className="inner-simple-text inner-simple-text--mobile-margin-big inner-simple-text--big inner-simple-text--margin-top-middle">
              <p>
                {t.contact?.secondText}
                <Link className="simple-link simple-link--no-color simple-link--no-underline"
                      href="mailto:job@mobileup.ru">
                  job@mobileup.ru
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
